import axios from 'axios';
import config from 'config.js';

// Constants
const GET_LOGS_REQUEST = 'dashboard/GET_LOGS_REQUEST';
const GET_LOGS_SUCCESS = 'dashboard/GET_LOGS_SUCCESS';
const GET_LOGS_FAILURE = 'dashboard/GET_LOGS_FAILURE';

const getEndpointStatus = (type) => {
  const types = {
    request: {
      loading: true,
      error: false,
      success: false
    },
    success: {
      loading: false,
      error: false,
      success: true
    },
    failure: {
      loading: false,
      error: true,
      success: false
    },
  };

  return types[type];
};

const endpoitInitialStatus = {
  loading: false,
  error: false,
  success: false
};

// Initiual State
const initialState = {
  logs: null,

  getLogs: { ...endpoitInitialStatus },
};

// Reducer
export default function reducer(state = JSON.parse(JSON.stringify(initialState)), action = {}) {
  if (action.type === GET_LOGS_REQUEST) {
    state.getLogs = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === GET_LOGS_SUCCESS) {
    state.getLogs = getEndpointStatus('success');
    state.logs = action.payload;

    return { ...state };
  }

  if (action.type === GET_LOGS_FAILURE) {
    state.getLogs = getEndpointStatus('failure');

    return { ...state };
  }

  return state;
}

// Action Creators
export function getLogs(params) {
  const request = () => { return { type: GET_LOGS_REQUEST } };
  const success = (res) => { return { type: GET_LOGS_SUCCESS, payload: res } };
  const failure = () => { return { type: GET_LOGS_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getLogs(params);

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

const services = {
  getLogs: async (params) => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/api/admin/logs`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        },
        params
      });

      return response;
    } catch (e) {
      return e.response;
    }
  }
};
